import { Text } from '@savvy-kit/foundations/text';
import { isNil } from 'es-toolkit';

type ItemDetailsRowProps = {
  readonly detailLabel: string;
  readonly disableTypography?: boolean;
  readonly value?: React.ReactNode;
  readonly verticalPadding?: number | string;
  readonly topPadding?: number | string;
  readonly bottomPadding?: number | string;
  readonly horizontalPadding?: number | string;
  readonly width?: number | string;
};

function ItemDetailsRow({
  detailLabel,
  disableTypography = false,
  value,
  width,
  verticalPadding = '2px',
  topPadding,
  bottomPadding,
  horizontalPadding = '0px',
}: ItemDetailsRowProps) {
  const usesSplitPadding = !isNil(topPadding) && !isNil(bottomPadding);

  return (
    <div
      className="flex"
      style={{
        paddingTop: usesSplitPadding ? topPadding : verticalPadding,
        paddingBottom: usesSplitPadding ? bottomPadding : verticalPadding,
        paddingLeft: horizontalPadding,
        paddingRight: horizontalPadding,
      }}
    >
      <div className="shrink-0" style={{ width: width || '200px' }}>
        <Text variant="subtitle-lg">{detailLabel}</Text>
      </div>
      <div className="flex flex-1">{disableTypography ? value : <Text className="text-left">{value}</Text>}</div>
    </div>
  );
}

export default ItemDetailsRow;
